// extracted by mini-css-extract-plugin
export default {"ctrl":"ctrl__tRSU0"};